const BUTTONS_BLOCK = 'contact-buttons';

const OLD_BUTTON_SIZES = {
  CARD: 'card',
  SIDEBAR: 'sidebar',
  SMALL: 'small'
};

const BUTTON_SIZES = {
  CARD: 'card',
  CONTACT_AND_REQUEST_CALL: 'contact-and-request-call',
  CONTACT_AND_REQUEST_CALL_MOBILE: 'contact-and-request-call-mobile',
  SIDEBAR: 'sidebar-new',
  SIDEBAR_CHARTER: 'sidebar-new-charter',
  SPECS_AND_DECKPLANS: 'specs-and-deckplans',
  MESSAGE: 'message'
};

const DATA_LAYER_OPTIONS = {
  BROCHURE_REQUEST: 'brochure-request',
  CALL_BACK_REQUEST: 'call-back-request',
  DECKPLANS_REQUEST: 'deckplans-request',
  FULL_SPECS_REQUEST: 'full-specs-request',
  MESSAGE: 'message',
  PHONE: 'phone',
  WEBSITE: 'website'
};

const FORM_BLOCK = 'contact-form';

const PRIVACY = {
  HREF: 'https://www.informa.com/privacy-policy',
  NAME: 'Privacy Policy'
};

const MESSAGE_TYPES = {
  BROCHURE: 'request_brochure',
  CALL_BACK: 'request_call_back',
  DECKPLANS: 'request_deck_plans',
  FULL_SPECS: 'request_full_specs',
  GENERAL: 'email_broker'
};

const MESSAGE_TYPE_TITLES = {
  [MESSAGE_TYPES.BROCHURE]: 'Request brochure',
  [MESSAGE_TYPES.CALL_BACK]: 'Request a call back',
  [MESSAGE_TYPES.DECKPLANS]: 'Request deck plans',
  [MESSAGE_TYPES.FULL_SPECS]: 'Request full specs',
  [MESSAGE_TYPES.GENERAL]: 'Email broker'
};

const MESSAGE_TYPE_TO_DATA_LAYER_OPTION = {
  [MESSAGE_TYPES.BROCHURE]: DATA_LAYER_OPTIONS.BROCHURE_REQUEST,
  [MESSAGE_TYPES.CALL_BACK]: DATA_LAYER_OPTIONS.CALL_BACK_REQUEST,
  [MESSAGE_TYPES.DECKPLANS]: DATA_LAYER_OPTIONS.DECKPLANS_REQUEST,
  [MESSAGE_TYPES.FULL_SPECS]: DATA_LAYER_OPTIONS.FULL_SPECS_REQUEST,
  [MESSAGE_TYPES.GENERAL]: DATA_LAYER_OPTIONS.MESSAGE
};

export {
  OLD_BUTTON_SIZES,
  BUTTONS_BLOCK,
  BUTTON_SIZES,
  MESSAGE_TYPE_TITLES,
  DATA_LAYER_OPTIONS,
  MESSAGE_TYPE_TO_DATA_LAYER_OPTION,
  MESSAGE_TYPES,
  FORM_BLOCK,
  PRIVACY
};
